import React from 'react';
import Redirect from 'react-router-dom/Redirect';
import TokenStorage from '../services/TokenStorage';
import Storage from '../services/Storage';
import { Route } from 'react-router-dom';

const PrivateRoute = ({ component: Component, ...rest}) => (
    <Route { ...rest} render={(props) => (
        TokenStorage.hasToken(TokenStorage.TYPE_ID) === true 
            ? <Component { ...props} customer={Storage.get('CUSTOMER')}/>
            : <Redirect to={{
                pathname: '/auth/login',
                state: { from: this.location }
            }} />
    )} />
);

export default PrivateRoute;


// WEBPACK FOOTER //
// ./src/components/PrivateRoute.js